import {
  ImageTextSplitBlock,
  PageSection,
  PageSectionTitle,
} from '@/src/packages/components';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';

export const ProductHighlights = () => {
  const {
    productVariant: {
      product: { highlights, sketch },
    },
  } = useProductContext();

  if (highlights.length === 0) return <></>;

  return (
    <PageSection>
      <PageSectionTitle>Highlights</PageSectionTitle>

      {highlights.map((highlight, n) => {
        return (
          <ImageTextSplitBlock
            key={n}
            imageURL={highlight.fields.image.fields.file.url}
            name={highlight.fields.title || ''}
            isFlipped={n % 2 === 0}
            description={highlight.fields.content || ''}
          />
        );
      })}
    </PageSection>
  );
};
